<script>
    import { onMount } from 'svelte'
    import { environment } from '../enviroments/enviroment.js'

    export let doc

    const client_id = environment.oidc_client_id

    onMount(() => {
		const ui = SwaggerUIBundle({
            url: `${doc}`,
            dom_id: '#swagger-ui',
            defaultModelsExpandDepth: -1,
            presets: [  
                SwaggerUIBundle.presets.apis,
                SwaggerUIStandalonePreset
            ],
        })
        // ui.initOAuth({
            // clientId: client_id,
            // // realm: "your-realms",
            // appName: "Datajalostamo",
            // scopeSeparator: " ",
            // scopes: "openid externalpermissions.query",
            // // additionalQueryStringParams: {test: "hello"},
            // useBasicAuthenticationWithAccessCodeGrant: false,
            // usePkceWithAuthorizationCodeGrant: false

        // })
    })

</script>

<div>
    <div id="swagger-ui"></div>
</div>
